import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr }
};

// Country-to-language mapping for geolocation-based detection (English + French only)
const countryToLang = {
  FR: 'fr', BE: 'fr', CH: 'fr', LU: 'fr', MC: 'fr', SN: 'fr', CI: 'fr', ML: 'fr',
  CM: 'fr', CD: 'fr', MG: 'fr', NE: 'fr', BF: 'fr', TG: 'fr', BJ: 'fr', GA: 'fr',
  TD: 'fr', CF: 'fr', CG: 'fr', DJ: 'fr', KM: 'fr', HT: 'fr', RW: 'fr', BI: 'fr',
};

// Custom geolocation detector
const geoDetector = {
  name: 'geolocation',
  lookup() {
    // Check if we already have a geo-detected language cached
    const cached = localStorage.getItem('i18n_geo_lang');
    if (cached) return cached;
    return undefined;
  },
  cacheUserLanguage() {}
};

// Trigger async geo detection on load (non-blocking)
async function detectGeoLanguage() {
  // Don't override if user already manually selected a language
  if (localStorage.getItem('i18nextLng')) return;

  try {
    const resp = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(3000) });
    if (resp.ok) {
      const data = await resp.json();
      const countryCode = data.country_code;
      const lang = countryToLang[countryCode];
      if (lang && lang !== i18n.language) {
        localStorage.setItem('i18n_geo_lang', lang);
        i18n.changeLanguage(lang);
      }
    }
  } catch (e) {
    // Silently fail — keep default language
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'geolocation', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

// Register custom detector
i18n.services.languageDetector.addDetector(geoDetector);

// Fire off geo detection (async, non-blocking)
detectGeoLanguage();

export default i18n;
